import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import styles from "./CreativeVision.module.css";
const TRUST_POINTS = ["20+ years experience", "500+ UK homeowners", "Free, no-obligation quotes"];
export default function CreativeVision() {
  return <section data-section-id="222531" id="elevating-your-exterior" className="relative flex min-h-[92vh] w-full flex-col justify-center overflow-hidden bg-background pt-24 pb-16 md:pt-32 md:pb-28">
      {/* Background Image */}
      <img src="https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/05/new-roof.jpg?v=8qmpfco9j2v" alt="Newly completed slate roof installation in Southampton" className="absolute inset-0 h-full w-full object-cover object-center" />

      {/* Charcoal gradient overlay (to-right: rgba(21,25,29,0.88) on left fading to rgba(21,25,29,0.5) on right) */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#15191D]/90 via-[#15191D]/75 to-[#15191D]/50" aria-hidden="true" />

      {/* Left-aligned hero content */}
      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="max-w-[760px] text-left">
          {/* Eyebrow */}
          <div className={`${styles["hero-fade-up"]} ${styles["hero-delay-1"]}`}>
            <span className="font-default text-sm font-semibold uppercase tracking-[4px] text-primary">
              FIRSTSTOP ROOFING LTD · SOUTHAMPTON &amp; HAMPSHIRE
            </span>
          </div>

          {/* Heading */}
          <h1 className={`mt-4 font-default text-[40px] font-bold leading-[1.1] tracking-tight text-white md:text-6xl lg:text-[72px] ${styles["hero-fade-up"]} ${styles["hero-delay-2"]}`}>
            Roofing Services in Southampton
          </h1>

          {/* Subline */}
          <p className={`mt-6 max-w-xl font-default text-lg text-slate-300 md:text-xl leading-relaxed ${styles["hero-fade-up"]} ${styles["hero-delay-3"]}`}>
            Trusted roofing specialists serving Southampton, Hampshire &amp; surrounding areas. Firststop Roofing Ltd provides expert roofing services, honest advice and reliable workmanship, from emergency repairs to complete new roofs, flat roofs, fascias and guttering.
          </p>

          {/* Buttons */}
          <div className={`mt-8 flex flex-col gap-4 sm:flex-row sm:items-center ${styles["hero-fade-up"]} ${styles["hero-delay-4"]}`}>
            <Button asChild className="h-14 rounded-lg bg-primary px-8 font-default text-base font-bold text-primary-foreground shadow-md transition-all duration-200 hover:-translate-y-0.5 hover:bg-primary-hover hover:shadow-lg">
              <Link to="/GetInTouchPage">Get a Free Quote</Link>
            </Button>

            <a href="tel:07443802652" className="inline-flex h-14 items-center justify-center rounded-lg border-2 border-white bg-transparent px-8 font-default text-base font-bold text-white shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:bg-white hover:text-[#15191D] hover:shadow-lg">
              Call 07443 802652
            </a>
          </div>

          {/* Trust Points */}
          <div className={`mt-10 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:gap-6 ${styles["hero-fade-up"]} ${styles["hero-delay-5"]}`}>
            {TRUST_POINTS.map(point => <div key={point} className="inline-flex items-center gap-2 text-sm font-medium text-white">
                <CheckCircle2 className="h-5 w-5 flex-shrink-0 text-primary" />
                <span>{point}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}